<template>
  <div
    class="
      md:flex
      mx-6
      md:mx-auto
      my-2
      w-full
      h-52
      bg-white
      p-5
      rounded rounded-lg
      border border-grey-200
    "
  >
    <img
      class="
        h-full
        w-full
        md:w-1/4
        object-contain
        rounded-lg rounded
        pb-5/6
        border border-grey-200
      "
      v-if="
        funnel.main_product.checkout_page_options.product_image
      "
      :src="
        funnel.main_product.checkout_page_options.product_image
      "
    />
    <gifts-icon
      v-else
      class="
        text-primary
        fill-current
        h-full
        w-full
        md:w-1/4
        object-scale-down
        rounded-lg rounded
        pb-5/6
        border border-grey-200
        py-2
      "
    />
    <div
      class="
        w-full
        md:w-3/4
        pl-4
        rounded-lg
        h-full
        flex flex-col
        content-between
        justify-between
      "
    >
      <div
        class="flex flex-col content-between justify-between h-40"
      >
        <div class="flex flex-col">
          <div class="flex items-center">
            <div class="w-3/4">
              <p
                class="text-lg text-dark font-bold mr-auto"
                v-line-clamp:27="1"
              >
                {{ funnel.main_product.name }}
              </p>
            </div>

            <div class="flex flex-row w-1/4 justify-end">
              <p>
                <span
                  class="text-dark font-bold"
                  v-if="
                    funnel.price_point_type == 3 ||
                    funnel.price_point_type == 4
                  "
                >
                  {{ funnel.number_of_installments }} X
                </span>
                <span class="text-dark font-bold">
                  {{ funnel.price | currency }}
                </span>
                <span
                  class="text-grey-500 font-normal text-sm"
                  v-if="funnel.price_point_type != 1"
                >
                  {{
                    resolveRecurringInterval(
                      funnel.recurring_interval
                    )
                  }}
                </span>
              </p>
            </div>
          </div>
          <div class="flex items-center">
            <div class="w-3/4">
              <p
                class="text-sm text-grey-700 mt-2"
                v-line-clamp:21="2"
              >
                {{ funnel.main_product.description }}
              </p>
            </div>
          </div>
        </div>
        <div class="flex flex-row">
          <div class="w-3/4">
            <p class="text-sm text-grey-700 mt-2">
              By
              {{ funnel.business ? funnel.business + ' | ' : '' }}
              {{ funnel.author }}
            </p>
          </div>
          <div class="flex flex-row w-1/4 justify-end">
            <p
              class="text-dark font-bold mt-2"
              v-if="funnel.commission_type == 'percent'"
            >
              {{ funnel.commission_value }}%
              <span class="text-grey-500 font-normal text-sm"
                >{{ $t('frontend_marketplace_commission') }}
              </span>
            </p>
            <p class="text-dark font-bold mt-2" v-else>
              {{ funnel.commission_value | currency }}
              <span class="text-grey-500 font-normal text-sm"
                >{{ $t('frontend_marketplace_commission') }}
              </span>
            </p>
          </div>
        </div>
      </div>

      <div
        class="
          flex
          items-center
          justify-between
          mt-2
          border-t-2 border-grey-200
          pt-2
        "
      >
        <div class="flex flex-row">
          <div
            class="
              flex flex-col
              text-center
              justify-end
              items-center
              mr-4
              text-sm
            "
          >
            <div class="text-center text-grey-500">
              {{ $t('frontend_marketplace_aps') }}
            </div>
            <div class="text-center mt-1">
              {{ funnel.gravity }}
            </div>
          </div>
          <div
            class="
              flex flex-col
              text-center
              justify-end
              items-center
              mr-4
              text-sm
            "
          >
            <div class="text-center text-grey-500">
              {{ $t('frontend_marketplace_funnel_epc_to_aff') }}
            </div>
            <div class="text-center mt-1">
              {{ funnel.aff_epc | currency }}
            </div>
          </div>
          <div
            class="
              flex flex-col
              text-center
              justify-end
              items-center
              mr-4
              text-sm
            "
          >
            <div class="text-center text-grey-500">
              {{ $t('frontend_marketplace_conversion_rate') }}
            </div>
            <div class="text-center mt-1">
              {{ funnel.conversion_rate }}%
            </div>
          </div>
          <div
            class="
              flex flex-col
              text-center
              justify-end
              items-center
              mr-4
              text-sm
            "
          >
            <div class="text-center text-grey-500">
              {{ $t('frontend_marketplace_refund_rate') }}
            </div>
            <div class="text-center mt-1">
              {{ funnel.refund_rate }}%
            </div>
          </div>
        </div>
        <div class="flex flex-row pt-2">
          <div class="w-1/5 px-2">
            <div
              v-if="funnel.is_funnel_affiliate_user == false"
              class="
                w-6
                h-6
                text-dark
                hover:text-primary
                cursor-pointer
              "
              @click="$emit('signUpForAffiliate', funnel.funnel_id)"
              v-tooltip="$t('frontend_join_program')"
            >
              <smile-icon class="w-5 h-5 fill-current"/>
            </div>
            <div
              v-else
              class="w-5 h-5 text-primary cursor-pointer"
              v-tooltip="$t('frontend_marketplace_already_aff')"
            >
              <smile-icon class="w-5 h-5 fill-current"/>
            </div>
          </div>

          <div class="w-1/5 px-2">
            <div
              v-if="funnel.sales_page"
              class="
                w-5
                h-5
                text-dark
                hover:text-primary
                cursor-pointer
              "
              @click="$emit('openUrlInNewTab', funnel.sales_page)"
              v-tooltip="$t('frontend_see_offer')"
            >
              <arrow-up-right-square-icon class="w-5 h-5 fill-current"/>
            </div>
            <div
              v-else
              class="w-5 h-5 text-grey-200 cursor-pointer"
              v-tooltip="$t('frontend_see_offer')"
            >
              <arrow-up-right-square-icon class="w-5 h-5 fill-current"/>
            </div>
          </div>

          <div class="w-1/5 px-2">
            <div
              v-if="funnel.is_funnel_affiliate_user == true"
              class="
                w-5
                h-5
                text-dark
                hover:text-primary
                cursor-pointer
              "
              @click="$emit('fetchAffiliateLinks', funnel.funnel_id)"
              v-tooltip="$t('affiliatesLinksColumns_links')"
            >
              <link-icon class="w-5 h-5 fill-current"/>
            </div>
            <div
              v-else
              class="w-5 h-5 text-grey-200 cursor-pointer"
              v-tooltip="$t('affiliatesLinksColumns_links')"
            >
              <link-icon class="w-5 h-5 fill-current"/>
            </div>
          </div>

          <div class="w-1/5 px-2">
            <div
              v-if="funnel.is_funnel_affiliate_user == true"
              class="
                w-5
                h-5
                text-dark
                hover:text-primary
                cursor-pointer
              "
              @click="$emit('openFunnelResource', funnel.funnel_id)"
              v-tooltip="
                $t('frontend_affiliate_promos_promo_tools')
              "
            >
              <megaphone-icon class="w-5 h-5 fill-current"/>
            </div>
            <div
              v-else
              class="w-5 h-5 text-grey-200 cursor-pointer"
              v-tooltip="
                $t('frontend_affiliate_promos_promo_tools')
              "
            >
              <megaphone-icon class="w-5 h-5 fill-current"/>
            </div>
          </div>

          <div class="w-1/5 px-2">
            <div
              v-if="funnel.main_product.jv_page"
              class="
                w-6
                h-6
                text-dark
                hover:text-primary
                cursor-pointer
              "
              @click="$emit('openUrlInNewTab', funnel.main_product.jv_page)"
              v-tooltip="$t('frontend_jv_signup_page')"
            >
              <handshake-icon class="w-5 h-5 fill-current"/>
            </div>
            <div
              v-else
              class="w-6 h-6 text-grey-200 cursor-pointer"
              v-tooltip="$t('frontend_jv_signup_page')"
            >
              <handshake-icon class="w-5 h-5 fill-current"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SmileIcon from '@/assets/images/icons/SmileIcon.svg';
import ArrowUpRightSquareIcon from '@/assets/images/icons/ArrowUpRightSquareIcon.svg';
import LinkIcon from '@/assets/images/icons/LinkIcon.svg';
import MegaphoneIcon from '@/assets/images/icons/MegaphoneIcon.svg';
import HandshakeIcon from '@/assets/images/icons/HandshakeIcon.svg';
import GiftsIcon from '@/assets/images/icons/GiftsIcon.svg';

export default {
  components: {
    SmileIcon,
    ArrowUpRightSquareIcon,
    LinkIcon,
    MegaphoneIcon,
    HandshakeIcon,
    GiftsIcon,
  },
  props: {
    funnel: {
      type: Object,
      required: true,
    },
  },
  methods: {
    resolveRecurringInterval(recurringInterval) {
      let recurringString = 'Weekly';

      switch (recurringInterval) {
        case 1:
          recurringString = 'Weekly';
          break;
        case 2:
          recurringString = 'Every 2 Weeks';
          break;
        case 3:
          recurringString = 'Monthly';
          break;
        case 4:
          recurringString = 'Every 2 Months';
          break;
        case 5:
          recurringString = 'Quarterly';
          break;
        case 9:
          recurringString = 'Every 4 Months';
          break;
        case 6:
          recurringString = 'Half-Yearly';
          break;
        case 7:
          recurringString = 'Yearly';
          break;
        case 8:
          recurringString = 'Every 2 Years';
          break;
        default:
          recurringString = 'Weekly';
          break;
      }

      return recurringString;
    },
  },
};
</script>
